export default "__VITE_ASSET__DKS51jDj__"